<app-nav></app-nav>


<section class="submission">
 
  <div class="container">
    <ng-container>
      <div class="col">
        
        
        <div class="col" *ngIf="cardVisibility">
          <p class="sub-title mt-2">E-cards</p>
          
          <div class="row">
            <div class="border rounded claimCards mt-4 mr-3 ml-3  col-md-5 pt-2 content-box"
              *ngFor="let detail of insuranceDetails;  let i = index">
              <span>
                <div class="row mt-4">
                  <div class="col-6 logo-position-1">
                    <img class="insurerLogo mb-3" src="{{detail.logo}}" alt="">
                  </div>
                  <div class="col-6 logo-position-2">
                    <img class="insurerLogo" src="	https://static-files-website.s3.ap-south-1.amazonaws.com/securenow_logo.svg" alt="">
                  </div>
                </div>
                <div class="row mt-2 policyName-div"><h4 class="policyName ml-4 mr-2 mb-3">{{detail.policyName}}</h4></div> 
                <div class="row">
                  <div class="col-6">
                    <div class="row cardFields">Card No.</div>
                    <div class="row cardFieldsVal">{{detail.cardNumber ? detail.cardNumber : detail.cardNo ? detail.cardNo : "NA"}}</div>
                  </div>
                  <div class="col-6">
                    <span class="row cardFields">Policy No.</span>
                    <span class="row cardFieldsVal">{{detail.policyNo ? detail.policyNo : detail.policyNumber ? detail.policyNumber :"NA"}}</span>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-6">
                    <div class="row cardFields">Insured</div>
                    <div class="row cardFieldsVal">{{detail.Insured ? detail.Insured : 'NA'}}</div>
                  </div>
                  <div class="col-6">
                    <div class="row cardFields">Sum Insured</div>
                    <div class="row cardFieldsVal">{{detail.sumInsured ? detail.sumInsured : 'NA'}}</div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-6">
                    <div class="row cardFields">Employee Id</div>
                    <div class="row cardFieldsVal">{{detail.empId ? detail.empId : 'NA'}}</div>
                  </div>
                  <div class="col-6">
                    <div class="row cardFields">Policy End Date</div>
                    <div class="row cardFieldsVal">{{(detail.endDate | date) ? (detail.endDate | date) : 'NA'}}</div>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-6">
                    <div class="row cardFields">Age</div>
                    <div class="row cardFieldsVal">{{detail.Age ? detail.Age : 'NA'}}</div>
                  </div>
                  <div class="col-6">
                    <div class="row cardFields">TPA Name</div>
                    <div class="row cardFieldsVal">{{detail.TPA_NAME ? detail.TPA_NAME : 'NA'}}</div>
                  </div>
                </div>
              </span>
              <div class="col-12 text-center mt-4 button-center">
                <div>
                  <button type="button" class="btn-bordered-blue dwnld-ecard" routerLink="/ecards-detail"
                    (click)="getCardNumber(detail._id)">
                    View Details
                  </button>
                </div>
                <div>
                  <button type="button" class="btn-bordered-blue ml-3 dwnld-ecard"
                  (click)="generateAndDownloadPDF(detail._id,i)">
                  Download E-card
                  </button>
                </div>

            </div>
          </div>
        </div>
        <ng-container *ngIf="showSecurenowFacilities">
        <div *ngIf="hasCard">
          <div class="addBlockCardsWeb mt-3 ml-3 mb-5">
            <img src="../../assets/images/Group 1081.svg" style="height: fit-content; width: 100%;position: relative;" />
            <p>Missing family members ?</p>
            <button type="button" class="addHerebtn" routerLink="/profile/add-family">Add Here </button>
        </div>
        
        <div class="addBlockCardsMob mt-3 ml-3">
          <div class="mobAddHere">
            <p>Missing family members ?</p>
            <button type="button" class="addHerebtnMob" routerLink="/profile/add-family">Add Here </button>
          </div>
       
        </div>
        </div>
      </ng-container>
        <div class="col text-center no-found" *ngIf="!cardVisibility && noDataFound">
          <label class="oops-text">Ooops....!</label>
          <img
            src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/no-data-found.jpg">
          <p>No data found.</p>
        </div>
      </div>
    </div>  
    </ng-container>

  </div>
  <!-- <div class="container">
        <div class="col" *ngIf="cardVisibility">
            <div class="border rounded pt-2 content-box" *ngFor="let detail of insuranceDetails;  let i = index">
                <span>
                    <div class="col-12">
                        <div class="row">
                            <div class="col-5 textWrap">Card Number :</div>
                            <div class="col-7">{{detail.cardNumber ? detail.cardNumber : 'NA'}}</div>
                        </div>
                        <div class="row">
                            <div class="col-5 textWrap">Insured :</div>
                            <div class="col-7">{{detail.Insured ? detail.Insured : 'NA'}}</div>
                        </div>
                        <div class="row">
                            <div class="col-5 textWrap">Gender : </div>
                            <div class="col-7">{{detail.Gender ? detail.Gender : 'NA'}}</div>
                        </div>
                        <div class="row">
                            <div class="col-5 textWrap">Relation : </div>
                            <div class="col-7">{{detail.Relation ? detail.Relation : 'NA'}}</div>
                        </div>
                    </div>
                    <div class="col-12 collapse" attr.id="accord{{i}}">
                        <div>
                            <div class="row">
                                <div class="col-5 textWrap">Company : </div>
                                <div class="col-7">{{detail.companyName ? detail.companyName : 'NA'}}</div>
                            </div>
                            <div class="row">
                                <div class="col-5 textWrap">Sum Insured : </div>
                                <div class="col-7">{{detail.sumInsured ? detail.sumInsured : 'NA'}}</div>
                            </div>
                            <div class="row">
                                <div class="col-5 textWrap">Email : </div>
                                <div class="col-7 textWrap">{{detail.email ? detail.email : 'NA'}}</div>
                            </div>
                            <div class="row">
                                <div class="col-5 textWrap">Phone Number : </div>
                                <div class="col-7">{{detail.phoneNumber ? detail.phoneNumber : 'NA'}}</div>
                            </div>
                            <div class="row">
                                <div class="col-5 textWrap">Employee Id : </div>
                                <div class="col-7">{{detail.empId ? detail.empId : 'NA'}}</div>
                            </div>
                            <div class="row">
                                <div class="col-5 textWrap">Policy No : </div>
                                <div class="col-7">{{detail.policyNumber ? detail.policyNumber : 'NA'}}</div>
                            </div>
                            <div class="row">
                                <div class="col-5 textWrap">Insurer : </div>
                                <div class="col-7">{{detail.Insurer ? detail.Insurer : 'NA'}}</div>
                            </div>
                            <div class="row">
                                <div class="col-5 textWrap">Maternity : </div>
                                <div class="col-7">{{detail.Maternity ? detail.Maternity : 'NA'}}</div>
                            </div>
                            <div class="row">
                                <div class="col-5 textWrap">Room Rent : </div>
                                <div class="col-7">{{detail.roomRent ? detail.roomRent : 'NA'}}</div>
                            </div>
                            <div class="row">
                                <div class="col-5 textWrap">Contract Limit : </div>
                                <div class="col-7">{{detail.contractLimit ? detail.contractLimit : 'NA'}}</div>
                            </div>
                            <div class="row">
                                <div class="col-5 textWrap">Policy Name : </div>
                                <div class="col-7">{{detail.policyName ? detail.policyName : 'NA'}}</div>
                            </div>
                            <div class="row">
                                <div class="col-5 textWrap">Policy : </div>
                                <div class="col-7">{{detail.policy ? detail.policy : 'NA'}}</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button class="arrow-btn" type="button" data-toggle="collapse"
                            attr.data-target="#accord{{i}}" aria-expanded="true"
                            attr.aria-controls="accord{{i}}">
                            <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/group-insurance/group-health-insurance-ng/Scroll+down.png"
                                class="img-fluid" alt="">
                        </button>
                    </div>
                </span>
already commented
                <span *ngIf="!detail.linkedToCard">
                    <div class="col-12 ">
                        <div class="row" *ngFor="let fieldDetails of detail.fields | slice:1:3;">
                            <div class="col-5 textWrap">{{transformName(fieldDetails.id)}} :</div>
                            <div class="col-7 overText">{{fieldDetails.value}}</div>
                        </div>
                    </div>
                    <div class="col-12 collapse" [attr.id]="'accord'+detail._id">
                        <div>
                            <div class="row" *ngFor="let fieldDetails of detail.fields | slice:4:20;">
                                <div class="col-5 textWrap">{{transformName(fieldDetails.id)}}:</div>
                                <div class="col-7 overText">{{fieldDetails.value}}</div>
                            </div>
                            <div class="row">
                                <div class="col-5 textWrap">Policy Type: </div>
                                <div class="col-7 overText">{{detail.managerPolicyType}}</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button class="arrow-btn" type="button" data-toggle="collapse"
                            [attr.data-target]="'#accord'+detail._id" aria-expanded="true"
                            [attr.aria-controls]="'accord'+detail._id">
                            <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/group-insurance/group-health-insurance-ng/Scroll+down.png"
                                class="img-fluid" alt="">
                        </button>
                    </div>
                </span>
                already commented
            </div>
        </div>
        <div class="col text-center no-found" *ngIf="!cardVisibility">
                <label class="oops-text">Ooops....!</label>
                <img src="https://static-files-website.s3.ap-south-1.amazonaws.com/securenow-web-app-new/common-icons/no-data-found.jpg">
                <p>No data found.</p>
              </div>
    </div> -->
    
  <div id="spinner" [hidden]="!loading">
    <div class="spinnerfull">
      <i class="fa fa-spinner fa-spin fa-3x"></i>
    </div>
  </div>
</section>